// Helpers voor HS-code / CN / TARIC onderscheid en validatie.
//
// Niveaus:
//  - HS-6  : Harmonized System (WCO) — wereldwijd, eerste 6 cijfers
//  - CN-8  : Combined Nomenclature — EU invoeraangifte (HS-6 + 2 EU-cijfers)
//  - TARIC : EU tarief-database — 10 cijfers, voor tarief-bevraging
//
// Geldigheid: enkel cijfers, lengte 6/8/10, eerste 2 cijfers (chapter) in 01-99.

const STRIP = (s) => String(s || '').replace(/[^0-9]/g, '');

export function hsLevel(code) {
  const c = STRIP(code);
  if (c.length === 6) return 'HS-6';
  if (c.length === 8) return 'CN-8';
  if (c.length === 10) return 'TARIC-10';
  return null;
}

export function hsLevelLabel(code) {
  const lvl = hsLevel(code);
  if (lvl === 'HS-6') return 'HS-6 · wereldwijd';
  if (lvl === 'CN-8') return 'CN-8 · EU invoer';
  if (lvl === 'TARIC-10') return 'TARIC-10 · EU tarief';
  return null;
}

// Geeft validatie-info terug. `ok=false` betekent ongeldige code.
export function hsValidate(code) {
  const c = STRIP(code);
  if (!c) return { ok: true, empty: true };
  if (c.length < 6) return { ok: false, error: 'Te kort — minstens 6 cijfers' };
  if (c.length === 7 || c.length === 9 || c.length > 10) return { ok: false, error: 'Lengte moet 6, 8 of 10 cijfers zijn' };
  const chapter = parseInt(c.slice(0, 2), 10);
  if (!chapter || chapter < 1 || chapter > 99) return { ok: false, error: 'Hoofdstuk (eerste 2 cijfers) moet 01-99 zijn' };
  // Hoofdstukken 77, 98, 99 zijn gereserveerd of speciale gebruik
  if (chapter === 77) return { ok: true, warning: 'Hoofdstuk 77 is gereserveerd — controleer code' };
  return { ok: true, level: hsLevel(c), chapter };
}

// Normaliseer voor weergave: enkel cijfers, geen punten/spaties.
export function hsNormalize(code) {
  return STRIP(code);
}
